<template>
  <v-container fluid class="text-center">
    <v-card class="elevation-5 mt-5">
      <v-toolbar dense dark color="secondary" elevation="2">
        <v-toolbar-title>
          Empleados
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text small @click="dialogs.import = true">
          Importar
          <v-icon right>mdi-arrow-up</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" :disabled="!isReading" elevation="0" color="secondary" outlined class="mx-2" @click="refresh()">
          Actualizar
          <v-icon right>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
      </v-card-title>
      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
      :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="primary" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item)">mdi-shield-account</v-icon></template><span>Roles</span></v-tooltip>
        </template>
        <template v-slot:footer.page-text="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template v-slot:no-data>
          No hay información disponible
        </template>
        <template v-slot:no-results>
          No se obtuvieron resultados
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogs.update" persistent max-width="600px">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Actualizar rol</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :loading="loading" :disabled="!isWriting" @click="update()">
            Actualizar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formUpdate" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.update.roles" label="Rol" :items="catalogues.roles"
                  :disabled="loading" required></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.import" persistent max-width="800px">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Importar información de Elevate</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn v-if="!forms.import.data.items.length" text small :loading="loading" @click="acceptImport()">
            Cargar
            <v-icon right>mdi-arrow-up</v-icon>
          </v-btn>
          <v-btn v-else-if="forms.import.data.items.length" text small :loading="loading" @click="saveImport()">
            Guardar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form v-show="!forms.import.data.items.length" ref="formImport" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-file-input v-model="forms.import.id" chips show-size label="Seleccionar archivo..." :accept="catalogues.mime_types" :disabled="loading"></v-file-input>
                </v-col>
              </v-row>
            </v-form>
            <v-data-table v-show="forms.import.data.items.length" :headers="forms.import.data.headers" :items="forms.import.data.items"
            :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [10, 20, -1] }" :items-per-page="10">
              <template v-slot:[`footer.page-text`]="props">
                Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
              <template v-slot:no-data>
                No hay información disponible
              </template>
              <template v-slot:no-results>
                No se obtuvieron resultados
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
import services from '@/utils/services'
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse'

export default {
  name: 'employees',
  data: () => ({
    loading: false,
    success: false,
    msgSuccess: '',
    error: false,
    msgError: '',
    search: '',
    headers: [
      { text: 'País', align: 'left', sortable: false, value: 'ubicacion.area_geografica.pais.nombre' },
      { text: 'Región', align: 'left', sortable: false, value: 'ubicacion.area_geografica.descripcion' },
      { text: 'Ubicación', align: 'left', sortable: false, value: 'ubicacion.nombre' },
      { text: 'Nombre', align: 'left', sortable: false, value: 'nombre' },
      { text: 'Número de empleado', align: 'left', sortable: false, value: 'numeroEmpleado' },
      { text: 'Login', align: 'left', sortable: false, value: 'login' },
      { text: 'Correo', align: 'left', sortable: false, value: 'correo' },
      { text: 'Puesto', align: 'left', sortable: false, value: 'puesto' },
      { text: 'Elevate ID', align: 'left', sortable: false, value: 'elevateID' },
      { text: 'Rol', align: 'left', sortable: false, value: 'rolesDesc' },
      { text: 'Acciones', align: 'left', sortable: false, value: 'actions' },
    ],
    items: [],
    selected: [],
    catalogues: {
      mime_types: [ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ],
      roles: []
    },
    forms: {
      update: {
        id: null,
        roles: null
      },
      import: {
        id: null,
        data: {
          headers: [
            { text: 'Num. Empleado', align: 'left', sortable: false, value: 'numeroEmpleado' },
            { text: 'ID Elevate', align: 'left', sortable: false, value: 'elevateID' }
          ],
          items: []
        }
      }
    },
    dialogs: {
      update: false,
      import: false
    }
  }),
  mounted() {
    if (this.isReading) {
      this.loading = true
      this.axios.get(services.routes.roles)
        .then(response => {
          let items = response.data.data
          for (let i = 0; i < items.length; i++) {
            this.catalogues.roles.push({
              text: items[i].rol,
              value: items[i].roleID
            })
          }
          this.catalogues.roles.push({
            text: '(Ninguno)',
            value: null
          })
          this.refresh()
        })
        .catch(error => {
          this.error = true
          this.msgError = 'El catálogo de roles no fue obtenido'
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    isReading: function() {
      return services.check(1, this.$route.path);
    },
    isWriting: function() {
      return services.check(2, this.$route.path);
    }
  },
  methods: {
    refresh() {
      this.loading = true
      this.axios.get(services.routes.empleados)
        .then(response => {
          this.items = response.data.data
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].nombre = (this.items[i].nombre + ' ' + this.items[i].apellidoPaterno + ' ' + this.items[i].apellidoMaterno).trim() 
          }
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].rolesDesc = []
            for (let j = 0; j < this.items[i].roles.length; j++) {
              this.items[i].rolesDesc.push(this.items[i].roles[j].rol)
            }
          }
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false
        })
    },
    cancel() {
      if (this.dialogs.update) {
        this.$refs.formUpdate.reset()
        this.forms.update = {
          id: null,
          roles: null
        }
      }
      else if (this.dialogs.import) {
        this.forms.import = {
          id: null,
          data: {
            headers: [
              { text: 'Num. Empleado', align: 'left', sortable: false, value: 'numeroEmpleado' },
              { text: 'ID Elevate', align: 'left', sortable: false, value: 'elevateID' }
            ],
            items: []
          }
        }
      }
      this.dialogs.update = false
      this.dialogs.import = false
    },
    view(data) {
      let ids = []
      for (let i = 0; i < data.roles.length; i++) {
        ids.push(data.roles[i].roleID)
      }
      this.forms.update = {
        id: data.lda_empleadoID,
        roles: (ids.length) ? ids[0] : null
      }
      this.dialogs.update = true
    },
    update() {
      this.loading = true
      let data = []
      data.push({
        empleado: this.forms.update.id,
        rol: this.forms.update.roles
      })
      this.axios.post(services.routes.empleados + '/assignRoles', { data })
        .then(response => {
          this.cancel()
          this.refresh()
          this.success = true
          this.msgSuccess = 'Roles actualizados exitosamente'
        })
        .catch(error => {
          this.error = true
          this.msgError = error.response.data.message || 'Servicio no disponible'
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadValues(data) {
      if (data.length && data[0].length >= this.forms.import.data.headers.length) {
        let idx = (this.forms.import.header) ? 1 : 0
        for (let i = idx; i < data.length; i++) {
          let row = {}
          for (let j = 0; j < this.forms.import.data.headers.length; j++) {
            row[this.forms.import.data.headers[j].value] = data[i][j]
          }
          this.forms.import.data.items.push(row)
        }
      }
      else {
        this.error = true
        this.msgError = 'El formato del archivo es inválido'
      }
    },
    acceptImport() {
      if (this.forms.import.id) {
        let fr = new FileReader();
        let file = this.forms.import.id
        let size = this.forms.import.id.size
        if (size <= 3000000) {
          this.loading = true
          setTimeout(() => {
            fr.onload = () => {
              let data = XLSX.read(fr.result, { type: "array" })
              let sheetNames = data.SheetNames
              let worksheet = data.Sheets[sheetNames[0]]
              let csv = XLSX.utils.sheet_to_csv(worksheet).trim()
              let values = Papa.parse(csv)
              if (values.data && values.data.length) {
                values = values.data
                this.loadValues(values)
              }
              else {
                this.error = true
                this.msgError = 'El archivo no fue leído correctamente'
              }
              this.loading = false
            }
            fr.onerror = () => {
              this.loading = false
              this.forms.import.id = null
              this.error = true
              this.msgError = 'El archivo no fue leído correctamente'
            }
            fr.readAsArrayBuffer(file);
          }, 500);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (3 MB)'
        }
      }
      else {
        this.error = true
        this.msgError = 'Seleccionar archivo'
      }
    },
    saveImport() {
      this.loading = true
      let data = this.forms.import.data.items
      this.axios.put(services.routes.empleados + '/elevate', { data })
        .then(response => {
          this.cancel()
          this.refresh()
          this.success = true
          this.msgSuccess = 'Información actualizada exitosamente'
        })
        .catch(error => {
          this.error = true
          this.msgError = error.response.data.message || 'Servicio no disponible'
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
}
</script>

<style scoped>
</style>
